<template>
  <!-- MENU CONTAINER SECTION BACKGROUND -->
  <div class="menu_container_section_background">

    <v-overlay :value="isLoading"><v-progress-circular indeterminate size="64"></v-progress-circular></v-overlay>
    <!--==================== MENU CONTAINER SECTION CONTAINER ====================-->
    <div class="menu_container_section_background">
      <div class="col-md-12 menu_container_section_container">
        <div v-for="(menu, index) in itensMenuImpressao" :key="index" class="menu_container_section_"
          @click="handleClick(menu)">
          <div v-if="menu.novo == 1" class="novo-badge-item-menu">Novo</div>
          <div v-if="menu.url == 'solicitacoes' && $store.state.solicitacoesPendentes >= 1" class="novo-badge-item-menu2"> {{ $store.state.solicitacoesPendentes }}</div>
          <figure class="menu_container_section_img">
            <img :src="menu.icon" />
          </figure>
          <div class="menu_container_section_text_container">
            <span class="menu_container_section_text_title">{{ menu.descricao }}</span>
          </div>
        </div>
      </div>
    </div>
    <!--==================== FIM MENU CONTAINER SECTION CONTAINER ========================= -->

    <!-- ============= DIALOGO ESCOLHA DA PAUTA ==============================-->
    <template>
      <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="690">
          <v-card>
            <v-card-title class="text-h5" style="background-color:#006699;color:white;"> Seleção do tipo de Pauta </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="12"></v-col>
                <v-col md="12"></v-col>
                <v-col md="12">
                  <v-row>
                    <v-col md="2"></v-col>
                    <v-col md="8">
                      <v-combobox v-model="tipoPautaSelected" outlined label="Selecione a pauta" :items="tipoPautasFiltradas" item-text="descricao" item-value="id" return-object></v-combobox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="darken-1" text @click="tipoPautaSelected = null; dialog = false">
                Fechar
              </v-btn>
              <v-btn color="green darken-1" text :disabled="tipoPautaSelected === null" @click="selectPauta()">
                Continuar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <!-- ==================== FIM DIALOGO ESCOLHA DA PAUTA ========================== -->


    <!-- ===================== DIALOGO ESCOLHA DA ESTATISTICA ======================== -->
    <template>
      <v-row justify="center">
        <v-dialog v-model="dialog2" persistent max-width="690">
          <v-card>
            <v-card-title class="text-h5" style="background-color:#006699;color:white;">
              Seleção do tipo de Mapa
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="12"></v-col>
                <v-col md="12"></v-col>
                <v-col md="12">
                  <v-row>
                    <v-col md="2"></v-col>
                    <v-col md="8">
                      <v-combobox v-model="estatisticaSelected" outlined label="Selecione o mapa" :items="estatistica"
                        item-text="descricao" item-value="id" return-object></v-combobox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="darken-1" text @click="estatisticaSelected = null; dialog2 = false">
                Fechar
              </v-btn>
              <v-btn color="green darken-1" text :disabled="estatisticaSelected === null" @click="selectEstatistica()">
                Continuar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <!-- ********************************************************************************************************* -->
  </div>
  <!-- FIM MENU CONTAINER SECTION BACKGROUND -->
</template>

<script>
import Swal from 'sweetalert2'
const ls = require('local-storage')
import ItensMenuUtilitarios from '@/utilitarios/ItensMenuUtilitarios';
import ItensMenuService from "@/services/ItensMenuService";
export default {
  data: () => ({
    itensMenuImpressao: [],
    menusAll: [],
    menusUsuario: [],
    isLoading: false,
    dialog: false,
    dialog2: false,
    tipoPautaSelected: null,
    estatisticaSelected: null,
    tipoPautas: [
      { descricao: 'Mini-Pauta', id: 1, permissao: [1, 2, 3, 4, 5, 6] },
      { descricao: 'Pauta Trimestral', id: 2, permissao: [1, 2, 3, 4, 5] },
      { descricao: 'Pauta Final 12ª', id: 3, permissao: [1, 2, 3, 4, 5] },
      { descricao: 'Pauta Final', id: 4, permissao: [1, 2, 3, 4, 5] },
    ],
    temAcessoInstituicao: true,
    estatistica:
      [
        { descricao: 'Mapa de Frequência', id: 1 },
        { descricao: 'Mapa Estatistico de Aproveitamento por Curso', id: 2 },
        { descricao: 'Mapa Estatistico de Aproveitamento por Trimestre', id: 3 },
        { descricao: 'Mapa Estatistico', id: 4 }
      ]
  }),
  
  async created() {
    this.isLoading = true;
    try {
      this.itensMenuImpressao = await ItensMenuUtilitarios.getItensByMenu(7);
      this.$store.state.idclasse = null;      
    } catch (error) {
      Swal.fire('Informação', 'Erro ao carregar a página!', 'error');
    } finally {
      this.isLoading = false;
    }
  },

  computed: {
    islicencaExpirada() {
      return ls.get('licencaExpirada')
    },
    licencaExpirada() {
      return ls.get('licencaExpirada')
    },
    nivelUsuario() {
      return ls.get('nivel_user')
    },
    tipoPautasFiltradas() {
    // Aqui você filtra os itens com base no nível de permissão do usuário
    return this.tipoPautas.filter(item => item.permissao.includes(this.nivelUsuario));
  }
  },
  methods: {
     async handleClick(menu) {
      // 1️⃣ Validação de licença
      if (menu.validarLicenca === 1 && this.isLicencaExpirada === 1) {
        Swal.fire(
          'Informação',
          'A sua licença de utilização está expirada! Por favor, entre em contato com o administrador do sistema.',
          'info'
        );
        return;
      }

      // 2️⃣ Validação de acesso da instituição
      if (menu.validarInstituicao == 1) {
        const verificacao = await ItensMenuService.getAcessoMenuInstituicao(menu.id);
        this.temAcessoInstituicao = verificacao.length > 0;
      }

      if (!this.temAcessoInstituicao) {
        Swal.fire(
          'Acesso Negado',
          'A sua instituição não possui permissão para acessar esta funcionalidade. Entre em contato com os administradores do sistema para mais informações.',
          'info'
        );
        this.temAcessoInstituicao = true;
        return;
      }

      // 3️⃣ Ação final: Navegar ou executar função
      if (menu.isRota === 1) {
        this.$store.state.fromMenu = 'impressao'
        this.$router.push(menu.url);
      } else if (menu.funcao) {
        eval(menu.funcao);
      }
    },

    

    IndisponivelMomento() {
      Swal.fire('Informação', 'Funcionalidade indisponível de momento.', 'warning')
    },

    showTipoPauta() {
      if (this.licencaExpirada) {
        Swal.fire('Informação', 'A sua licença de utilização encontra-se expirada! Por favor, entre em contato com o administrador do sistema!', 'info');
      } else {
        this.dialog = true
      }
    },

    selectPauta() {
      switch (this.tipoPautaSelected.id) {
        case 1:
          this.setRouter('mini-pautas')
          break;
        case 2:
          this.setRouter('pauta-trimestral')
          break;
        case 3:
          this.setRouter('pauta-anual')
          break;
        case 4:
          this.setRouter('pauta-final')
          break;
        default:
          Swal.fire('Informação', 'Tipo de Pauta inválido', 'warning')
          break;
      }
    },
    selectEstatistica() {
      switch (this.estatisticaSelected.id) {
        case 1:
          this.setRouter('mapafrequencia')
          break;
        case 2:
          this.setRouter('mapaaproveitamentoCurso')
          break;
        case 3:
          this.setRouter('mapaaproveitamentoTrimestre')
          break;
        case 4:
          this.setRouter('mapaestatistico')
          break;
        default:
          Swal.fire('Informação', 'Tipo de Estatística inválida', 'warning')
          break;
      }
    },

    setRouter(endereco) {
      this.$router.push(endereco);
    }
  }
}
</script>

<style>
.novo-badge-item-menu2 {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: #f30000;
  color: #ffffff;
  padding: 2px 5px;
  border-radius: 3px;
  font-size: 10px;
  font-weight: bold;
  animation: blink 1s linear infinite;
}

@keyframes blink {
  50% {
    opacity: 0;
  }
}
</style>